import { Modal } from '@/components/ui/Modal';

const SHORTCUTS: { keys: string; label: string }[] = [
  { keys: 'g d', label: 'Go to Dashboard' },
  { keys: 'g a', label: 'Go to Applications' },
  { keys: 'g q', label: 'Go to Queue' },
  { keys: 'g n', label: 'Go to Notifications' },
  { keys: 'g r', label: 'Go to Resumes' },
  { keys: 'g w', label: 'Go to Workers' },
  { keys: 'g s', label: 'Go to Settings' },
  { keys: '/', label: 'Focus search (Applications)' },
  { keys: '?', label: 'Show this help' },
];

export function HelpModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts">
      <ul className="space-y-1.5 text-sm">
        {SHORTCUTS.map((s) => (
          <li key={s.keys} className="flex items-center justify-between">
            <span className="text-gray-700 dark:text-gray-200">{s.label}</span>
            <kbd className="rounded border border-gray-300 bg-gray-50 px-1.5 py-0.5 font-mono text-xs text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
              {s.keys}
            </kbd>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
